<template>
  <div class="row guardian-cont mt-4">
    <div class="offset-md-4 offset-lg-3 col-md-8 col-sm-12 mt-auto mb-auto">
      <h2>Featuring Our "Guardian" Software</h2>
      <h1>
        All of the perks of a Dedicated Network Tunnel, none of the complicated
        setup.
      </h1>
      <p class="mb-2">
        Replace your remote proxy and complex tunnel solutions with our custom
        built Guardian server-side client. Enable intelligent, native protection
        on your Windows and Linux servers for anything and everything you host,
        on any protocol, automatically and instantly.
      </p>
      <p>Setup is fast and fully automated.</p>
      <router-link to="/signup">
        <button class="create-btn" style="height: 2.5em; margin-top: 0;">
          <span>Get Guardian</span>
        </button>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "GetGuardian",
  props: {},
  computed: {
    header: function() {
      return {};
    },
  },
};
</script>

<style scoped>
.guardian-cont {
  min-height: 20em;
  border-radius: 5px;
  background-color: #10161f;
  background-image: url("~@/assets/img/guardian_background.png");
  background-size: cover;
}
.guardian-cont > div {
  padding: 1em;
}
@media only screen and (max-width: 768px) {
  .guardian-cont {
    background-image: none;
  }
}
</style>
